const ADMIN_PAGES = [
    { path: "/dashboard", title: "Dashbord" },
    { path: "/newsletters", title: "Nyhetsbrev" }
];

export default ADMIN_PAGES;